// eslint-disable-next-line
export const EXCLUDED_GAMES = {
  GAMES_LIST: 'wagering-contribution/getGames',
  GET_EXCLUDED_GAMES: 'excluded-games/find',
  SAVE_EXCLUDED_GAMES: 'excluded-games/save',
}
